import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationCompany: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path stroke="#C0C2C9" d="M10 297.5h290" />
      <path
        d="m278.294 46.075-1.748-2.875C261.832 18.976 235.227 4.372 207.17 6.145a74.39 74.39 0 0 0-10.76 1.471c-25.501 5.455-47.693 24.721-56.893 49.395-5.38 14.51-6.92 31.224-17.19 42.738-13.362 14.993-36.046 15.45-55.985 14.839-19.94-.611-42.644-.087-55.94 14.96C2.078 138.953-.571 152.388.1 164.997c1.796 33.434 25.084 63.314 54.755 78.166 29.671 14.853 64.561 16.183 97.002 9.654 45.488-9.157 88.683-34.294 114.669-73.115 25.985-38.821 32.556-91.716 11.768-133.627Z"
        fill="#F0F1F3"
      />
      <ellipse cx={86.946} cy={71.973} rx={18.858} ry={18.61} fill="#F0F1F3" />
      <path d="M205 56h17l8 241h-33l8-241Z" fill="#fff" />
      <path
        d="M86.742 139.005c.014-2.209 1.803-4.005 4.012-4.005h72.502c2.209 0 3.987 1.795 4.003 4.004.494 69.677 13.684 135.034 17.634 153.091.552 2.526-1.376 4.905-3.961 4.905H74.012c-2.567 0-4.49-2.348-3.967-4.861 3.736-17.941 16.232-83.037 16.697-153.134Z"
        fill={theme ? theme.primary[200] : '#DBDDE1'}
      />
      <g filter="url(#a)">
        <rect
          x={134}
          y={230}
          width={112}
          height={67}
          rx={4}
          fill={theme ? theme.primary[500] : '#C0C2C9'}
        />
      </g>
      <rect x={155} y={251} width={25} height={25} rx={4} fill="#fff" />
      <rect x={200} y={251} width={25} height={25} rx={4} fill="#fff" />
      <ellipse
        cx={213.5}
        cy={56}
        rx={8.5}
        ry={3}
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M204.632 67h17.733l.231 7h-18.195l.231-7ZM204.197 80h18.6l.234 7h-19.062l.228-7Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M243.025 234.619c-3.209 3.662-4.493 8.948-3.851 13.441.642 4.494 3.21 8.232 2.756 12.234-.453 3.965-3.889 8.231-4.04 11.894-.151 3.663 2.945 6.721 6.646 6.872 3.662.151 7.891-2.605 12.536-1.85 4.682.755 9.779 5.022 12.195 4.153 2.417-.868 2.19-6.91 2.115-11.327-.113-4.38-.038-7.212.642-10.421.717-3.21 2.076-6.835 1.321-9.742-.755-2.945-3.662-5.173-6.796-8.911-3.134-3.738-6.495-8.986-10.799-10.572-4.304-1.586-9.477.528-12.725 4.229Z"
        fill={theme ? theme.secondary[200] : '#E9EAEC'}
      />
      <path
        d="M255.509 242.684a.5.5 0 0 1 1-.005l1.699 53.805a.498.498 0 0 1-.5.516h-2.831a.5.5 0 0 1-.5-.511l1.132-53.805Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M245.138 246.204a.499.499 0 0 1 .564-.824l10.757 6.564a.502.502 0 0 1 .239.427v1.651a.5.5 0 0 1-.803.398l-10.757-8.216ZM268.635 250.977a.5.5 0 0 0-.667-.743l-12.058 9.676a.502.502 0 0 0-.187.39v2.407a.501.501 0 0 0 .854.353l12.058-12.083ZM245.968 258.835a.5.5 0 0 1 .79-.61l9.393 10.809a.502.502 0 0 1 .123.328v2.973a.5.5 0 0 1-.914.282l-9.392-13.782Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.825 229.617c-3.469 3.958-4.856 9.672-4.162 14.528.693 4.856 3.469 8.897 2.979 13.222-.49 4.286-4.204 8.897-4.367 12.856-.163 3.958 3.183 7.264 7.183 7.427 3.958.163 8.53-2.816 13.549-2 5.06.817 10.57 5.428 13.181 4.49 2.612-.939 2.367-7.469 2.286-12.243-.123-4.734-.041-7.795.694-11.264.775-3.469 2.244-7.387 1.428-10.529-.816-3.183-3.959-5.591-7.346-9.631-3.387-4.041-7.02-9.713-11.672-11.427-4.652-1.714-10.243.571-13.753 4.571Z"
        fill={theme ? theme.secondary[200] : '#E9EAEC'}
      />
      <path
        d="M62.359 238.335a.5.5 0 0 1 1-.005l1.836 58.154a.499.499 0 0 1-.5.516h-3.06a.5.5 0 0 1-.5-.51l1.224-58.155Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.133 242.106a.5.5 0 0 1 .564-.824l11.627 7.095a.5.5 0 0 1 .24.427v1.784a.501.501 0 0 1-.804.398l-11.627-8.88ZM76.476 247.269a.5.5 0 0 0-.667-.743l-13.032 10.458a.5.5 0 0 0-.187.39v2.601a.5.5 0 0 0 .854.353l13.032-13.059ZM52.039 255.767a.5.5 0 0 1 .79-.609l10.152 11.683a.5.5 0 0 1 .123.328v3.213a.499.499 0 0 1-.913.281l-10.152-14.896Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M105.796 211.753c4.395 5.015 6.153 12.255 5.274 18.408-.879 6.154-4.395 11.273-3.775 16.755.621 5.429 5.326 11.272 5.533 16.288.207 5.016-4.033 9.205-9.101 9.412-5.016.206-10.807-3.568-17.168-2.534-6.412 1.034-13.393 6.877-16.702 5.688-3.31-1.189-3-9.463-2.896-15.513.155-5.999.052-9.877-.879-14.272-.982-4.396-2.844-9.36-1.81-13.341 1.034-4.034 5.016-7.085 9.308-12.204 4.292-5.119 8.894-12.307 14.79-14.479 5.894-2.172 12.978.724 17.426 5.792Z"
        fill={theme ? theme.secondary[200] : '#E9EAEC'}
      />
      <path
        d="M88.514 222.802a.5.5 0 0 0-1-.005l-2.327 73.687a.5.5 0 0 0 .5.516h3.878a.5.5 0 0 0 .5-.51l-1.551-73.688Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.79 227.472a.499.499 0 0 0-.564-.824l-14.731 8.99a.5.5 0 0 0-.24.427v2.261a.5.5 0 0 0 .804.397l14.731-11.251ZM70.854 234.025a.5.5 0 0 1 .667-.743l16.513 13.252a.5.5 0 0 1 .187.39v3.295a.499.499 0 0 1-.854.354l-16.513-16.548ZM101.613 244.813a.5.5 0 0 0-.79-.61L87.96 259.006a.501.501 0 0 0-.123.328v4.071a.5.5 0 0 0 .913.282l12.863-18.874Z"
        fill={theme ? theme.secondary[700] : '#888D9B'}
        stroke={theme ? theme.secondary[700] : '#888D9B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="a"
          x={132}
          y={228.5}
          width={116}
          height={71}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1820_7466"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1820_7466"
            result="effect2_dropShadow_1820_7466"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1820_7466"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationCompany;
